export { default as useUniversalFilterText } from './useUniversalFilterText';
